import gql from "graphql-tag";

export const CREATE_APPROVAL_BY_EXAMINER = gql`
  mutation createApprovalByExaminer($contractCode: String!) {
    createApprovalByExaminer(contractCode: $contractCode)
  }
`;
